<template>
	<div>
		<div v-if="loading">
			<div class="success--text text-h4 text-center">
				در حال دریافت اطلاعات...
			</div>
		</div>
		<div v-else>
			<div class="mb-8 text-center">تعطیلی های تقویم را مشخص نمایید:</div>
			<div class="d-flex justify-center mb-5">
				<div class="cal-container">
					<div class="d-flex justify-space-around">
						<v-btn small @click="previousMonth">ماه قبل</v-btn>
						<div class="d-flex flex-column justify-center">{{ activeDate.pdate.getMonthName() }}
							{{ activeDate.pdate.getYear() }}</div>
						<v-btn small @click="nextMonth">ماه بعد</v-btn>
					</div>
					<div class="d-flex text-center header mt-2">
						<div class="day">ش</div>
						<div class="day">ی</div>
						<div class="day">د</div>
						<div class="day">س</div>
						<div class="day">چ</div>
						<div class="day">پ</div>
						<div class="day">ج</div>
					</div>
					<div class="d-flex text-center weeks" v-for="(week, index) in weeks" :key="index">
						<div class="day" v-for="(day, index) in week" :key="index">
							<div v-if="day.pdate" class="val" @click="toggleSelection(day)" :class="[items.some(x => x.pdate.getFullDate() === day.pdate.getFullDate()) ? 'off' : '']">
								{{ day.pdate.getDate() }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<v-card-actions>
			<v-spacer />
			<v-btn @click="$emit('callbck', false)">
				بستن
			</v-btn>
			<v-btn color="blue" dark :loading="submitLoading" @click="save">
				ذخیره
			</v-btn>
			<v-spacer />
		</v-card-actions>

		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
import { emptyId } from '@/util/emptyId'
import toast from '@/util/toast'
import { call, get } from 'vuex-pathify'
import _ from 'lodash'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import PersianDate from '@/plugins/persian-date.js'

export default {
	name: 'OffDates',
	props: {
		data: { type: Object },
	},
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
		'date-picker': VuePersianDatetimePicker,
	},
	data() {
		return {
			emptyId: emptyId,
			dialog: false,
			errorMessages: '',
			items: [],
			localData: {},
			submitLoading: false,
			loading: false,
			offDatePickerValidatioin: '',
			activeDate: {
				date: new Date(),
				pdate: new PersianDate(new Date())
			}
		}
	},
	computed: {
		...get('offDates', [
			'settings'
		]),
		weeks() {
			let firstDay = this.firstDayOfMonthInPersian()
			let counter = 1 - firstDay.pdate.getDay()
			let maxDaysInMonth = (firstDay.pdate.getMonth() > 6 ? 30 : 31)
			let weeksCount = Math.floor((firstDay.pdate.getMonth() > 6 ? 30 : 31) / 7) + 2
			let weeks = []
			for (let i = 0; i < weeksCount; i++) {
				if (counter > maxDaysInMonth)
					break
				let week = []
				for (let j = 0; j < 7; j++) {
					let day = {}
					if (counter > 0 && counter <= maxDaysInMonth) {
						let date = new Date(firstDay.date)
						day = { date: date, pdate: new PersianDate(date) }
						firstDay.date.setDate(firstDay.date.getDate() + 1)
					}
					week.push(day)
					counter++
				}
				weeks.push(week)
			}
			return weeks
		}
	},
	mounted() {
		this.loadData()
	},
	methods: {
		...call('offDates/*'),
		loadData() {
			this.loading = true
			this.fetch().then(res => {
				this.loading = false
				this.items = res.map(x => {
					return {
						id: x.id,
						pdate: new PersianDate(x.date),
						date: x.date,
						title: x.title
					}
				})
			})
				.catch(err => {
					toast.error(err.message)
					this.loading = false
				})
		},
		save() {
			this.submitLoading = true
			let data = _.cloneDeep(this.items)
			this.sync(data).then(x => {
				toast.success('اطلاعات با موفقیت ذخیره شد.')
				this.submitLoading = false
				this.$emit('callbck')
			}).catch(err => {
				toast.error(err.message)
				this.submitLoading = false
			})
		},
		firstDayOfMonthInPersian() {
			var date = new Date(this.activeDate.date)
			date = new Date(date.setDate(date.getDate() - (this.activeDate.pdate.getDate() - 1)))
			var pdate = new PersianDate(date)
			return { pdate, date }
		},
		toggleSelection(item) {
			let index = this.items.findIndex(x => x.pdate.getFullDate() === item.pdate.getFullDate())
			if (index > -1) {
				this.items.splice(index, 1)
			} else {
				this.items.push({
					id: emptyId,
					pdate: item.pdate,
					date: item.date,
					title: ''
				})
			}
		},
		previousMonth() {
			let m = (this.activeDate.pdate.getMonth() > 6 ? 30 : 31)
			let newDate = new Date(this.activeDate.date.setDate(this.activeDate.date.getDate() - m))
			this.activeDate = {
				date: newDate,
				pdate: new PersianDate(newDate)
			}
		},
		nextMonth() {
			let m = (this.activeDate.pdate.getMonth() > 6 ? 30 : 31)
			let newDate = new Date(this.activeDate.date.setDate(this.activeDate.date.getDate() + m))
			this.activeDate = {
				date: newDate,
				pdate: new PersianDate(newDate)
			}
		}
	},
}
</script>
<style scoped>
.cal-container {
	width: 300px;
	border: 1px solid #fff;
	border-radius: 10px;
}

.cal-container .header {
	border-bottom: 1px solid #ddd;
}

.cal-container .header .day {
	padding: 10px;
	width: 75px;
	color: #ccc;
}

.cal-container .weeks {}

.cal-container .weeks .day {
	padding: 5px;
	width: 75px;
	cursor: pointer;
}

.cal-container .weeks .day .val {
	transition: 0.3s all;
	border-radius: 40px;
	padding: 5px;
}

.cal-container .weeks .day .val:hover {
	background: skyblue;
	color: #fff;
}

.cal-container .weeks .day .val.off {
	border-radius: 40px;
	background: pink;
	color: #f00;
}
</style>
